/**
 * Tutarı ondalık nokta ile 2 basamaklı string olarak döner (örn. 1231.12)
 */

/**
 * Tutarı Türkçe biçimde 2 ondalık basamakla döner (örn. 1.231,12)
 */
export const formatDecimalAmount = (amount: number | null | undefined): string => {
  const value = amount ?? 0;
  if (Number.isNaN(value)) {
    return '0,00';
  }
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Form girişini sayıya çevirir. Virgül veya nokta ondalık ayırıcı kabul edilir (örn. 120,05 / 120.05).
 */
export const parseDecimalAmountInput = (value: string): number | null => {
  const trimmed = value.trim().replace(/\s/g, '').replace(/₺/g, '');
  if (!trimmed) {
    return null;
  }

  let normalized = trimmed;
  const hasComma = normalized.includes(',');
  const hasDot = normalized.includes('.');

  if (hasComma && hasDot) {
    if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = normalized.replace(/,/g, '');
    }
  } else if (hasComma) {
    normalized = normalized.replace(',', '.');
  }

  const num = Number.parseFloat(normalized);
  if (Number.isNaN(num) || !Number.isFinite(num)) {
    return null;
  }

  return Math.round(num * 100) / 100;
};

/** Form alanında gösterim için Türkçe tutar string'i (örn. 120,05) */
export const formatDecimalAmountInput = (amount: number): string => {
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/** API / FormData için invariant ondalık string (örn. 120.05) */
export const formatDecimalAmountForApi = (amount: number): string => {
  return amount.toFixed(2);
};
